<template>
  <ion-page class="bg-white">
    <security-header />
    <ion-content>
      <div class="px-7 pt-6 max-w-xl mx-auto">
        <security-icon />
        <security-details />
        <security-change-password />
        <security-mfa />
        <security-biometrics v-if="isNative && biometryAvailCheck" />
        <security-reset-pin v-if="isNative" />
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>
import { computed } from 'vue';
import SecurityHeader from "@/components/security/SecurityHeader.vue";
import SecurityIcon from "@/components/security/SecurityIcon.vue";
import SecurityDetails from "@/components/security/SecurityDetails.vue";
import SecurityChangePassword from "@/components/security/SecurityChangePassword.vue";
import SecurityMfa from "@/components/security/SecurityMfa.vue";
import SecurityResetPin from "@/components/security/SecurityResetPin.vue";
import SecurityBiometrics from "@/components/security/SecurityBiometrics.vue";
const isNative = computed(() => Capacitor.isNativePlatform());
import { useBiometryAuth } from '@/composables/biometryAuth';
const { biometryAvailCheck } = useBiometryAuth();
</script>
